import { defineComponent as r, computed as n } from "vue";
const l = r({
  name: "CsDataSheet",
  props: {
    entries: {
      type: Array,
      required: !0
    }
  },
  setup(t) {
    return {
      filledEntries: n(() => {
        const e = [...t.entries];
        return e.length % 2 === 1 && e.push({
          label: "",
          value: ""
        }), e;
      })
    };
  }
});
export {
  l as default
};
